import 'select2';

export default function initSelects() {
  const initializeSelect = ($select) => {
    $select.select2({
      minimumResultsForSearch: Infinity,
      width: '100%',
    });
  };

  const selects = jQuery('.selects');
  if (selects.length) {
    selects.each((_, element) => {
      initializeSelect(jQuery(element));
    });
  }
}
